import * as React from 'react';
import { Router, RouterContext } from 'react-router';
import { ClientController } from './controller';
import { ClientModel } from './model';
import { Provider, observer } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import { ApolloProvider } from 'react-apollo';

export interface ClientViewProps {
  model: ClientModel;
  controller: ClientController;
  routerProps: any;
  server?: boolean;
}

@observer
export class ClientView extends React.PureComponent<ClientViewProps, {}> {
  render() {
    const Handler = this.props.server ? RouterContext : Router;

    return (
      <IntlProvider locale={this.props.model.i18n.locale} messages={this.props.model.i18n.messages}>
        <Provider model={this.props.model} controller={this.props.controller}>
          <ApolloProvider client={this.props.model.graphql.client}>
            <Handler {...this.props.routerProps} onUpdate={this.handleUpdate}/>
          </ApolloProvider>
        </Provider>
      </IntlProvider>
    )
  }

  handleUpdate = () => {
    this.props.controller.bugsnag.refresh();
  }
}
